<template>
    <v-card>
        <v-card-title class="headline">
            {{ $i18n.t('newUser' )}}

            <v-spacer/>

            <v-btn @click="$store.commit('setCreateUserDialog', false)">
                {{ $t('cancel') }}
                <v-icon right>clear</v-icon>
            </v-btn>
            <v-btn @click="submit" class="ml-7" color="teal">
                {{ $t('save') }}
                <v-icon right>done</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text>
            <v-container grid-list-xl>
                <v-form ref="form" @submit="submit">
                    <v-text-field v-model="getUser.name" :rules="nameRules" :label="$i18n.t('name')" class="pa-0 ma-0"/>
                    <v-text-field v-model="getUser.surname1" :rules="surname1Rules" :label="$i18n.t('surname1')" class="pa-0 ma-0"/>
                    <v-text-field v-model="getUser.surname2" :rules="surname2Rules" :label="$i18n.t('surname2')" class="pa-0 ma-0"/>
                    <v-text-field v-model="getUser.email" :rules="emailRules" :label="$i18n.t('email')" class="pa-0 ma-0"/>
                    <v-text-field
                        v-model="getUser.newPassword"
                        :rules="passwordRules"
                        :type="passwordHidden ? 'password' : 'text'"
                        :append-outer-icon="passwordHidden ? 'visibility' : 'visibility_off'"
                        :label="$t('password')"
                        @click:append-outer="() => (passwordHidden = !passwordHidden)"
                        class="my-0 body-1 font-weight-light"/>
                </v-form>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { i18n } from '@/main.js' 

export default {
    data(){
        return {
            passwordHidden: true,

            nameRules: [
                v => !!v || this.$i18n.t('noName'),
                v => !v || v.length < 50 || this.$i18n.t('longName'),
            ],
            surname1Rules: [
                v => !!v || this.$i18n.t('noSurname'),
                v => !v || v.length < 50 || this.$i18n.t('longSurname'),
            ],
            surname2Rules: [
                v => !v || v.length < 50 || this.$i18n.t('longSurname'),
            ],
            emailRules: [
                v => !!v || this.$i18n.t('noEmail'),
                v => !v || /.+@.+/.test(v) || this.$i18n.t('emailNotValid'),
            ],
            passwordRules: [
                v => !!v || this.$i18n.t('noPassword'),
                v => !v || v.indexOf(' ') < 0 || this.$i18n.t('spaces'),
                v => !v || v.length >= 8 || this.$i18n.t('shortPassword'),
            ],
        }
    },

    methods: {
        submit() {
            if (this.$refs.form.validate())
                this.$store.dispatch('createUser')
        },
    },

    computed: {
        ...mapGetters([
            'isLoading',
            'getCreateUserDialog',
            'getUser',
        ]),
    },

    watch: {
        getCreateUserDialog() {
            this.$refs.form.resetValidation()
        }
    }
}
</script>
